import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import multipleAccountsActions from '../actions/multipleAccounts';

function selectAccountMultipleAccounts(store, action) {
    const selectedAccountDetails = action.payload.selectedAccountDetails;
    request.post(`/${config.url_prefix}/api/multipleAccounts`)
        .send({
            data: selectedAccountDetails
        })
        .set('x-homeaway-site', selectedAccountDetails.primarySite.name)
        .end((error, response) => {
            if (error) {
                const errorKey = 'internal.server.error';
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(multipleAccountsActions.alertError(errorKey));
            } else if (response.statusCode === 200) {
                // Redirect to the selected account site
                let {protocol, host, pathname} = window.location;
                pathname = `/p/onboard?site=${selectedAccountDetails.primarySite.name}`;
                window.location = `${protocol}//${host}${pathname}`;
            } else {
                const errorKey = 'ipmob.error.process.request';
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(multipleAccountsActions.alertError(errorKey));
            }
        });
}

export default selectAccountMultipleAccounts;
